import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IBooking, ICalendarEvents } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'
import { BookingScheduleFragment } from '@api/fragments'

interface IPayload {
  viewer: {
    employee: {
      bookings: IBooking[]
      calendarEvents: ICalendarEvents[]
      pastCalendarEvents: ICalendarEvents[]
    }
  }
}

const queryHandler = handleFetchResult<IPayload, (IBooking | ICalendarEvents)[]>({
  handler: (data) => [
    ...data.viewer.employee.bookings,
    ...data.viewer.employee.calendarEvents,
    ...data.viewer.employee.pastCalendarEvents,
  ],
  name: 'Current Booking list',
})

export default function currentBookings(fromDate: string): Promise<(IBooking | ICalendarEvents)[]> {
  return client.gql
    .query({ query: currentBookingsQuery, variables: { fromDate } })
    .then(queryHandler)
}

export const currentBookingsQuery = gql`
  query currentBookings($fromDate: String) {
    viewer {
      id
      employee {
        bookings(fromDate: $fromDate) {
          id
          startDate
          endDate
          checkedIn
          passedHealthCheck
          bookingSchedule {
            ...BookingScheduleFragment
          }
          employee {
            id
          }
          healthCheck {
            disabled
            locationHeathCheckGroup {
              id
            }
          }
          note
          space {
            id
            externalId
            code
            floor {
              id
              name
              code
              enforceQrCode
              printableQrCodeUsageTypes
              building {
                id
                name
                city
                timezone
                address
                code
              }
              bookingWorkdayTimeFrom
              bookingWorkdayTimeTo
            }
            usageType {
              displayName
              name
            }
            x
            y
          }
        }
        pastCalendarEvents {
          id
          summary
          start
          end
          options
          calendar {
            id
            space {
              id
              code
              name
              capacity
              externalId
              comment
              floor {
                id
                code
                name
                building {
                  id
                  code
                  name
                  city
                  timezone
                  address
                }
              }
              spaceType {
                id
                name
                interactivity
              }
              assets {
                id
                url
              }
            }
          }
        }
        calendarEvents {
          id
          summary
          start
          end
          options
          calendar {
            id
            space {
              id
              code
              name
              capacity
              externalId
              comment
              floor {
                id
                code
                name
                building {
                  id
                  code
                  name
                  city
                  timezone
                  address
                }
              }
              spaceType {
                id
                name
                interactivity
              }
              assets {
                id
                url
              }
            }
          }
        }
      }
    }
  }
  ${BookingScheduleFragment}
`
